import { FC } from 'react'

type Props = {
  quantity: number
}

const Quantity: FC<Props> = ({ quantity }) => {
  return (
    <span
      className={`absolute p-2.5 top-auto bottom-0 left-0 ${
        quantity <= 1 ? 'bg-gray-200 text-black' : 'bg-bidfta-red text-white'
      } rounded-br-none rounded-tr-md text-14 font-bold`}
    >
      {quantity} qty
    </span>
  )
}

export default Quantity
